export default __webpack_public_path__ + "static/media/insta_1.4c0eb574.svg";